
    export default 
    {
    "aeAccountDisconnect": {
        "title": "Il tuo account DSers non è più collegato ad AliExpress. Per questo motivo i dati degli ordini e dei prodotti sono scomparsi temporaneamente. I dati verranno recuperati una volta collegato ad un nuovo account AliExpress."
    }
}